import Vue from 'vue'
import Router from 'vue-router'

import Login from '@/pages/users/login'
import ArticlesList from '@/pages/clip/index'
import Settings from '@/pages/settings/index'
import UpdateEmail from '@/pages/settings/mail'
import ConfirmEmail from '@/pages/settings/emailverification'
import NotFound from '@/components/NotFound'
import DeleteAccount from '@/pages/settings/accountdeleteconfirm'
import AccountDeleted from '@/pages/settings/accountdeleted'

import cognitoUser from '@/api/cognito-user'

Vue.use(Router)

let router = new Router({
  mode:"history",
  history: true,
  routes: [
    /**
     * Home
     */
    {
      path: '/login',
      name: 'Login',
      component: Login,
      beforeEnter: function (to, from, next) {
        if (cognitoUser.isLogin() === true) {
          return next('/')
        }
        next()
      }      
    },
    {
      path: '/confirm',
      name: 'Confirm',
      component: ConfirmEmail,
      beforeEnter: function (to, from, next) {
        if (cognitoUser.isLogin() === false) {
          if(from.path !== "/update-email"){
            return next('/login')
          }
        }
        next()
      }        
    },    
    {
      path: '/settings',
      name: 'Settings',
      component: Settings,
      beforeEnter: function (to, from, next) {
        if (cognitoUser.isLogin() === false) {
          return next('/login')
        }
        next()
      }      
    },
    {
      path: '/update-email',
      name: 'Change Email',
      component: UpdateEmail,
      beforeEnter: function (to, from, next) {
        if (cognitoUser.isLogin() === false) {
          return next('/login')
        }
        next()
      }      
    },
    {
      path: '/deleteaccount',
      name: 'Account Delete',
      component: DeleteAccount,
      beforeEnter: function (to, from, next) {
        if (cognitoUser.isLogin() === false) {
          return next('/login')
        }
        next()
      }      
    },     
    {
      path: '/accountremoved',
      name: 'Account Deleted',
      component: AccountDeleted,
      beforeEnter: function (to, from, next) {
        if(from.path !== "/deleteaccount"){
          return next('/')
        }
        next()
      }      
    },       
    {
      path: '/',
      name: 'Home',
      component: ArticlesList,
      beforeEnter: function (to, from, next) {
        if (cognitoUser.isLogin() === false) {
          return next('/login')
        }
        next()
      }
    },
    {
      path: '*',
      name: 'NotFound',
      component: NotFound
    }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js